import { useAuth } from '../auth/AuthProvider'
import { textoDoBloqueio } from '../auth/assinatura'
import { WHATSAPP_DO_SUPORTE as WHATSAPP } from '../lib/suporte'

export default function AssinaturaInativa({ status }: { status: string }) {
  const { sair } = useAuth()
  const texto = textoDoBloqueio(status)

  return (
    <main
      className="min-h-screen flex items-center justify-center bg-slate-100 p-4"
      data-testid="assinatura-inativa"
    >
      <div className="w-full max-w-sm bg-white rounded-xl shadow-sm p-6 space-y-4">
        <h1 className="text-xl font-bold text-slate-800">{texto.titulo}</h1>
        <p className="text-sm text-slate-600">{texto.corpo}</p>
        <a
          href={WHATSAPP}
          className="block w-full text-center bg-teal-700 text-white rounded-lg py-2 font-medium"
        >
          Falar no WhatsApp
        </a>
        <button
          type="button"
          onClick={() => void sair()}
          className="w-full border border-slate-300 text-slate-700 rounded-lg py-2"
        >
          Sair
        </button>
      </div>
    </main>
  )
}
